// src/utils/AxiosUtils.js
import axios from 'axios';

// 创建axios实例
const apiClient = axios.create({
  // baseURL: 'https://api2.seattletaotao.com', // 基础URL
  baseURL: '//api2.pxin1.com/',// 'http://www.ttao13.com',   'https://api2.pxin1.com',// 基础URLh
  headers: {
    'Content-Type': 'application/json',
    // 默认情况下，如果有需要，可以在这里设置固定的Authorization头
    // 'Authorization': `Bearer ${YOUR_32_CHAR_TOKEN}`
  },
  timeout: 6000, // 请求超时时间
});

// 请求拦截器，用于添加Token
apiClient.interceptors.request.use((config) => {
  // 从Vuex或LocalStorage中获取Token，这里仅为示例
  const token = localStorage.getItem('token') || '';
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

// 响应拦截器，处理错误
apiClient.interceptors.response.use(
  (response) => response.data,
  (error) => {
    // 错误处理逻辑，例如检查错误状态码
    return Promise.reject(error);
  }
);

export async function get(url, params = {}, config = {}) {
  const response = await apiClient.get(url, { params, ...config });
  return response;
}

export async function post(url, data = {}, config = {}) {
  const response = await apiClient.post(url, data, config);
  return response;
}

// 分页示例方法
export function paginate(url, params = {}) {
  return get(url, { ...params, _page: params.page || 1, _limit: params.limit || 10 });
}